import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import CustomTooltip from "../custom_tooltip/CustomTooltip";
import { BiInfoCircle } from "react-icons/bi";
import IconButton from "../buttons/IconButton";

const TableUserConnections = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="card djaCenter py-5">
        <p className="h5">No se ha podido cargar la información</p>
      </div>
    );
  }
  const connectedUsers = data?.filter((item) => item?.connected).length ?? 0;
  return (
    <div className="card" aria-label="table">
      <DataTable
        value={data}
        header={
          <div className="djaBetween">
            <h4>
              <b>Conexiones de Usuario</b>
            </h4>
            <span>
              <i>Conectados: {connectedUsers}</i>
            </span>
          </div>
        }
        paginator
        rows={50}
        rowsPerPageOptions={[5, 10, 25, 50]}
        filterDisplay="row"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
        filter
        responsiveLayout="scroll"
        aria-label="some"
      >
        <Column
          field={"user.name"}
          header={"Nombre"}
          sortable
          filter
          filterMatchMode={["contains"]}
          showFilterMenu={false}
          body={(row) => {
            return row?.user?.name ? row.user.name : "-";
          }}
        />
        <Column
          field={"user.username"}
          header={"Usuario"}
          sortable
          filter
          filterMatchMode={["contains"]}
          showFilterMenu={false}
          body={(row) => {
            return row?.user?.username ? row.user.username : "-";
          }}
        />
        <Column
          field={"connected"}
          header={"Estado"}
          showFilterMenu={false}
          sortable
          body={(row) => {
            return row?.connected ? (
              <div className="text-success">
                <b>Conectado</b>
              </div>
            ) : (
              <div>
                <b>Desconectado</b>
              </div>
            );
          }}
        />
        <Column
          field="last_seen"
          header="Última Conexión"
          sortable
          sortField="date_to_filter"
          filter
          filterMatchMode="contains"
          showFilterMenu={false}
          body={(row) => {
            return row?.last_seen;
          }}
        />

        <Column
          header={"Detalles"}
          style={{ maxWidth: "7rem" }}
          body={(row) => {
            if (
              !row?.connection_downlink &&
              !row.connection_downlink &&
              !row?.connection_rtt
            )
              return null;
            return (
              <div className="djaCenter">
                <CustomTooltip
                  position={"left"}
                  subtitle={
                    <div>
                      <div>Conexión: {row?.connection_effective_type}</div>
                      <div>Ancho de banda: {row?.connection_downlink} Mbps</div>
                      <div>Latencia: {row?.connection_rtt} ms</div>
                    </div>
                  }
                >
                  <IconButton
                    disabled
                    color="secondary"
                    icon={<BiInfoCircle size={"30px"} />}
                    size="small"
                    text
                  ></IconButton>
                </CustomTooltip>
              </div>
            );
          }}
        />
      </DataTable>
    </div>
  );
};

export default TableUserConnections;
